import styled, { keyframes, css } from 'styled-components';

import { colors } from '../../../styles/theme';

interface Props {
  color?: string;
  size?: string;
}

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

export default styled.div<Props>`
  margin-left: auto;
  margin-right: auto;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 2px solid currentColor;
  border-top-color: transparent;
  animation: ${spin} 1s linear infinite;

  ${({ size }: Props) =>
    size &&
    css`
      width: ${size};
      height: ${size};
    `}

  ${({ color }: Props) =>
    color &&
    css`
      border-color: ${colors(`${color}.base`)};
      border-top-color: transparent;
    `}
`;
